import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Image, Modal } from "react-bootstrap";
import Switch from "react-switch";
import { delete_item_admin_menu_setup } from "../../../../store/actions/SuperAdminActions/adminCreateCatalogue";
import isEmpty from "../../../../store/validation/is-Empty";
import { SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP } from "../../../../store/types";
import { ITEMTYPEVEG } from "../../../../enums/OrderEnums";

const GlobalCatalogViewDetails = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const auth = useSelector((state) => state.auth?.user?.accessToken);
  const deleteItem = (id) => {
    const token = auth;
    dispatch(delete_item_admin_menu_setup(id, token, onSuccessDelete));
  };

  const onSuccessDelete = () => {
    setShow(false);
  };

  const takeToEditPage = (itemId) => {
    dispatch({ type: SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP, payload: itemId });
    if (props.types === "chain") {
      history.push("/superadmin-chain-catalogue/add-item");
    } else {
      history.push("/superadmin-global-catalogue/add-item");
    }
  };

  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={() => {
          setShow(true);
        }}
      >
        <Image
          src={require("../../../../assets/images/UserManagement/eye.svg")}
          alt="View offer"
          title="View offer"
          fluid
        />
      </Button>
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header className="pt-3 border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">
            Item Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          {props.displayView !== "GlobalCatalog" ? (
            <React.Fragment>
              <div className="row mb-5">
                <div
                  className={`${
                    props?.actionBy === "CATEGORY_VIEW" ? "col-12" : "col-8"
                  }`}
                >
                  <div className="row">
                    <div className="col-4">
                      <h5 className="f11-400 opacity5 mb-1">
                        {props?.actionBy === "CATEGORY_VIEW"
                          ? "Category"
                          : "Item"}{" "}
                        ID
                      </h5>
                      <p className="f12-500">#{props?.data?._id}</p>
                    </div>
                    <div className="col-4">
                      <h5 className="f11-400 opacity5 mb-1">
                        {props?.actionBy === "CATEGORY_VIEW"
                          ? "Category"
                          : "Item"}{" "}
                        Name
                      </h5>
                      <div className="d-flex">
                        {props?.actionBy === "CATEGORY_VIEW"
                          ? ""
                          : ITEMTYPEVEG.map((type, index) => {
                              return (
                                <React.Fragment key={index}>
                                  {props?.data?.itemType === type?.value ? (
                                    <Image
                                      width="20px"
                                      src={type.url}
                                      alt={type.title}
                                      title={type.title}
                                      className="vegIcon"
                                      fluid
                                    />
                                  ) : null}
                                </React.Fragment>
                              );
                            })}
                        <div className="f12-500">{props?.data?.name}</div>
                      </div>
                      {props?.actionBy === "CATEGORY_VIEW" ? (
                        ""
                      ) : (
                        <hr className="mt-2 mb-2" />
                      )}
                      {props?.actionBy === "CATEGORY_VIEW" ? (
                        ""
                      ) : (
                        <div className="d-flex">
                          <Image
                            src={props?.data?.primary_food_type?.icon}
                            alt="Food type"
                            title="Food type"
                            width="20px"
                            fluid
                          />{" "}
                          <div className="f12-500 ml-3">
                            {" "}
                            {props?.data?.primary_food_type?.title}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="col-4">
                      <h5 className="f11-400 opacity5 mb-1">
                        {props?.actionBy === "CATEGORY_VIEW"
                          ? "Category Availability"
                          : "Item Category"}
                      </h5>
                      <p
                        className="f14-500"
                        style={{
                          color: `${
                            props?.actionBy === "CATEGORY_VIEW"
                              ? "green"
                              : "red"
                          }`,
                        }}
                      >
                        {props?.actionBy === "CATEGORY_VIEW"
                          ? props?.data?.availability
                          : props?.data?.category?.name}
                      </p>
                    </div>
                  </div>
                </div>
                {props?.actionBy === "CATEGORY_VIEW" ? (
                  ""
                ) : (
                  <div className="col-4">
                    <h5 className="f11-700 mb-1">More Actions</h5>
                    <div className="d-flex align-items-center">
                      <div className="">
                        <Button
                          variant="link"
                          className="enIconBtn mr-3"
                          onClick={() => takeToEditPage(props?.data?._id)}
                        >
                          <Image
                            src={require("../../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </Button>
                      </div>
                      <div className="">
                        <GlobalCatalogDeletePopUp
                          title="Remove Item"
                          subtitle="Are you sure you want to remove this item from catalogue?"
                          type="item"
                          deleteItem={() => deleteItem(props?.data?._id)}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="row mb-5">
                <div className="col-8">
                  <div className="row">
                    {/* <div className="col-4">
                  <h5 className="f11-400 opacity5 mb-1">Description</h5>
                  <p className="f14-500"></p>
                </div> */}
                    <div
                      className={`${
                        props?.actionBy === "CATEGORY_VIEW" ? "col-6" : "col-4"
                      }`}
                    >
                      <h5 className="f11-400 opacity5 mb-1">Status</h5>
                      <p className="f14-500">
                        {props?.data?.status ? "Active" : "Not Active"}
                      </p>
                    </div>
                    <div
                      className={`${
                        props?.actionBy === "CATEGORY_VIEW" ? "col-6" : "col-4"
                      }`}
                    >
                      <h5 className="f11-400 opacity5 mb-1">
                        {props?.actionBy === "CATEGORY_VIEW"
                          ? "Product Classification"
                          : "Cuisine Type"}
                      </h5>
                      <p className="f14-500">
                        {props?.actionBy === "CATEGORY_VIEW"
                          ? props?.data?.product_classification
                          : props?.data?.cuisin_type?.title}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="row">
                    <div className="col-6">
                      <h5 className="f11-400 opacity5 mb-1">
                        {props?.actionBy === "CATEGORY_VIEW"
                          ? "Category Classification"
                          : "No. Of Views"}
                      </h5>
                      <p className="f14-500">
                        {props?.actionBy === "CATEGORY_VIEW" ? (
                          ""
                        ) : (
                          <img
                            src={require("../../../../assets/images/UserManagement/view--on.svg")}
                            className="img-fluid mr-2"
                            alt="View Count"
                            title="View Count"
                          />
                        )}
                        {props?.actionBy === "CATEGORY_VIEW"
                          ? props?.data?.category_classification
                          : props?.data?.view_count}
                      </p>
                    </div>
                    {props?.actionBy === "CATEGORY_VIEW" ? (
                      ""
                    ) : (
                      <div className="col-6">
                        <h5 className="f11-400 opacity5 mb-1">Item Ordered</h5>
                        <p className="f14-500">
                          <img
                            src={require("../../../../assets/images/RightNavigationIcon/ordering.svg")}
                            className="img-fluid mr-2"
                            alt="Order Count"
                            title="Order Count"
                            style={{ width: "14px" }}
                          />
                          {props?.data?.order_count}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row mb-5">
                <div className="col-12">
                  <h5 className="f11-400 opacity5 mb-1">
                    {props?.actionBy === "CATEGORY_VIEW" ? "Category" : "Item"}{" "}
                    Description
                  </h5>
                  <p className="f11-400">{props?.data?.description}</p>
                </div>
              </div>
              {props?.actionBy === "CATEGORY_VIEW" ? (
                ""
              ) : (
                <div className="row mb-5">
                  <div className="col-12">
                    <h5 className="f11-400 opacity5 mb-1">
                      Ingredients Description
                    </h5>
                    <p className="f11-400">
                      {props?.data?.ingredient_description}
                    </p>
                  </div>
                </div>
              )}
              <div className="row mb-5">
                <div className="col-12">
                  <h5 className="f11-400 opacity5 mb-1">Keywords</h5>
                  <div className="d-flex">
                    {!isEmpty(props.data.keywords) &&
                      props.data?.keywords.map((item, index) => {
                        if (index === 0) {
                          return (
                            <React.Fragment key={index}>
                              <p className="f11-400">{item}</p>
                            </React.Fragment>
                          );
                        } else if (item) {
                          return (
                            <React.Fragment key={index}>
                              <p className="f11-400">{", " + item}</p>
                            </React.Fragment>
                          );
                        }
                      })}
                  </div>
                </div>
              </div>
              {props?.actionBy === "CATEGORY_VIEW" ? (
                ""
              ) : (
                <div className="row mb-5">
                  <div className="col-3">
                    <h5 className="f11-400 opacity5 mb-1">Nutritional Info.</h5>
                    <p className="f14-500">
                      {props?.data?.nutritional_info ? "Yes" : "No"}
                    </p>
                  </div>
                  <div className="col-3">
                    <h5 className="f11-400 opacity5 mb-1">Allergy Info.</h5>
                    <p className="f14-500">
                      {props?.data?.allergy_information?.value ? "Yes" : "No"}
                    </p>
                  </div>
                  <div className="col-3">
                    <h5 className="f11-400 opacity5 mb-1">Personalization</h5>
                    <p className="f14-500">
                      {props?.data?.allergy_information?.personalization_status
                        ? "Yes"
                        : "No"}
                    </p>
                  </div>
                </div>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {" "}
              <div
                className="row align-items-center pt-3 pb-3"
                style={{ boxShadow: "0px 3px 6px #6E6E6E21" }}
              >
                <div className="col-2">
                  <Image />
                </div>
                <div className="col-7">
                  <div className="f14-500">{props.data && props.data.name}</div>
                </div>
                <div className="col-3">
                  <div className="f14-500 text-break">
                    ID : #{props.data && props.data._id}
                  </div>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-7 f10-700">Description</div>
                <div className="col-2 f10-700">No.of Items</div>
                <div className="col-3 f10-700">Status</div>
              </div>
              <div className="row">
                <div className="col-7 f10-400">
                  {props.data && props.data.description}
                </div>
                <div className="col-2 f10-400">
                  {" "}
                  {props.data && props.data.items && props.data.items.length}
                </div>
                <div className="col-3">
                  <div className="f15-500">
                    <Switch
                      //   onChange={() => {}}
                      checked={props.data && props.data.status}
                      offColor="#EEEEEE"
                      onColor="#EEEEEE"
                      offHandleColor="#212121"
                      onHandleColor="#59F832"
                      handleDiameter={24}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={15}
                      width={41}
                      boxShadow="-2px 0px 5px #0000003B"
                      activeBoxShadow="-2px 0px 5px #0000003B"
                      id="material-switch"
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export const GlobalCatalogDeletePopUp = (props) => {
  const [show, setShow] = useState(false);
  const deleteCatalog = () => {
    if (props.type === "global") {
      props.deleteGlobalCatalog();
    } else if (props.type === "chain") {
      props.deleteChainCatalog();
    } else if (props.type === "category") {
      props.deleteCategory();
    } else if (props.type === "item") {
      props.deleteItem();
    }
  };

  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={() => {
          setShow(true);
        }}
      >
        <Image
          src={require("../../../../assets/images/UserManagement/Delete.svg")}
          alt="Delete catalog"
          title="Delete catalog"
          fluid
        />
      </Button>
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
        }}
        centered
      >
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          <div className="f12-500">{props.subtitle}</div>
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          {/* <div class="justify-content-start border-0 modal-footer"> */}
          <button
            type="button"
            class="btn-md mr-4 px-5 btn btn-outline-secondary"
            onClick={() => setShow(false)}
          >
            No
          </button>
          <button
            type="button"
            class="btn-md px-5 btn btn-danger"
            onClick={() => deleteCatalog()}
          >
            Yes
          </button>
          {/* </div> */}
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default GlobalCatalogViewDetails;
